
// Startup gate: progress follows completed work, never a timer that reveals an unfinished table.
const GameLoading = (() => {
  const screen = document.querySelector('#splash');
  const status = document.querySelector('#loadingStatus');
  const progress = document.querySelector('#loadingProgress');
  const start = document.querySelector('#btnEnter');
  const retry = document.querySelector('#loadingRetry');
  let state = 'loading';
  const watchdog = setTimeout(() => fail(new Error('Startup timed out. Please reload and try again.')), 120000);
  function stage(value, message) {
    if (state !== 'loading') return;
    progress.value = value;
    status.textContent = message;
    screen.dataset.loading = 'true';
  }
  function fail(error) {
    if (state !== 'loading') return;
    state = 'failed';
    clearTimeout(watchdog);
    screen.dataset.loading = 'failed';
    screen.setAttribute('aria-busy', 'false');
    status.textContent = 'The table could not finish loading. Please reload to try again.';
    start.disabled = true;
    start.textContent = 'UNABLE TO LOAD';
    retry.hidden = false;
    console.error('Game startup failed:', error);
  }
  function complete() {
    if (state !== 'loading') throw new Error('Startup did not complete successfully');
    clearTimeout(watchdog);
    progress.value = 100;
    status.textContent = 'Table ready. Your game starts when you are.';
    screen.dataset.loading = 'ready';
    screen.setAttribute('aria-busy', 'false');
    start.disabled = false;
    start.hidden = false;
    start.textContent = 'ENTER THE ARCADE ↗';
    state = 'ready';
  }
  // Installed before the engine scripts. Early keyboard/touch input cannot dismiss the loading screen.
  for (const type of ['keydown', 'keyup', 'pointerdown', 'pointerup', 'click']) {
    addEventListener(type, event => {
      if (state === 'ready' || event.target?.closest?.('#loadingRetry')) return;
      if (type === 'keydown' && (event.key === 'Tab' || event.metaKey || event.ctrlKey || event.altKey)) return;
      event.stopImmediatePropagation();
      if (event.cancelable) event.preventDefault();
    }, {capture: true});
  }
  addEventListener('error', event => fail(event.error || new Error(event.message)));
  addEventListener('unhandledrejection', event => fail(event.reason));
  retry.addEventListener('click', () => location.reload());
  // Two frames let the DOM progress update paint before the next synchronous build phase.
  const paint = () => new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  let lastYield = performance.now();
  async function yieldIfNeeded() {
    if (performance.now() - lastYield < 8) return;
    await paint();
    lastYield = performance.now();
  }
  return {stage, fail, complete, paint, yieldIfNeeded, get ready() {return state === 'ready';}};
})();
